import React from "react";
import { Eye } from "lucide-react";

const blockKeys = (e) => {
  if ((e.key === "Enter" || e.key === " ") && !e.target.closest("[data-view-allowed]")) {
    e.preventDefault();
    e.stopPropagation();
  }
};

export const ViewOnlyWrap = ({ perm, testId, children }) => {
  if (perm === "hidden") return null;
  if (perm !== "view") return children;
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 p-2 text-sm rounded border border-amber-200 bg-amber-50 text-amber-800" data-testid={testId}>
        <Eye className="h-4 w-4" /> Bu sekmede sadece görüntüleme yetkiniz var.
      </div>
      <div className="view-only-tab" onKeyDownCapture={blockKeys}>{children}</div>
    </div>
  );
};
